export default __webpack_public_path__ + "static/media/device.215df7ed.png";